/* eslint-disable @typescript-eslint/no-unsafe-function-type */
// Based on https://overreacted.io/making-setinterval-declarative-with-react-hooks/
import { useEffect, useRef } from 'react';

const useIntervalWithReset = (callback: Function, delay: number | null, resetTrigger: number) => {
  const savedCallback = useRef<Function>(() => {});
  const interval = useRef<number | null>(null);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay !== null) {
      interval.current = setInterval(() => savedCallback.current(), delay ?? 0);
      return () => interval.current ? clearInterval(interval.current) : undefined;
    }
    return undefined;
  }, [delay, resetTrigger]);
};

export default useIntervalWithReset;
